import { useTranslation } from 'react-i18next';
import React, { FC, useEffect, useState } from 'react';
import { Collapse, message, Button, Checkbox, Form, Input } from 'antd';
import { ArrowLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Link, useParams } from "react-router-dom";
import axios from 'axios'
import logo from '../home/descarga.png'
import { InterfaceIdea } from '../../interfaces/app.interfaces';
import './Idea.css';
import FormInformation from './FormInformation';

const panelStyle = {
    marginBottom: 24,
    border: 'none',
    borderRadius: 18,
    backgroundColor: 'white',
    fontSize: 20,
    fontWeight: 500,
    padding: 16,
};

const Idea = () => {

    const { Panel } = Collapse
    const { id } = useParams();
    const [messageApi, contextHolder] = message.useMessage();

    const [idea, setIdea] = useState<InterfaceIdea>();

    const { t } = useTranslation();
    const URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        let lan = localStorage.getItem('lan');
        axios.get(`${URL}/idea/getdataideadetail/${lan}/${id}`)
            .then(({ data }) => {
                if (localStorage.getItem('lan') === data.language) {
                    messageApi.info(`${t('Translation found')}`);
                } else {
                    messageApi.info(`${t('Translation not found')}`);
                }
                setIdea(data)
            })
            .catch(err => console.log(err))
    }, [localStorage.getItem('lan')])

    const onChange = (key: string | string[]) => {
        console.log(key);
    };

    return (
        <>
            {contextHolder}
            <div className="idea-info">

                <div className="idea-header">

                    <div className="header-left">

                        <div className="header-title">
                            <Link to={`/`}> <ArrowLeftOutlined /> </Link>
                            <h2>{idea?.name}</h2>
                        </div>

                        <div className="header-desc">
                            <p>{idea?.description}</p>
                        </div>
                    </div>

                    <div className="header-right">
                        <div>
                            {
                                idea?.bytesImg ?
                                    <img src={`${idea?.headerImage}${idea?.bytesImg}`} alt='Idea' /> :
                                    <img src={logo} alt='Idea' />
                            }
                        </div>
                    </div>

                </div>

                <Collapse
                    bordered={false}
                    onChange={onChange}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    className="container-collapse"
                >

                    <Panel header={t('What for')} key="1" style={panelStyle}>
                        <p>{idea?.whatFor}</p>
                    </Panel>
                    <Panel header={t('For whom')} key="2" style={panelStyle}>
                        <p>{idea?.forWhom}</p>
                    </Panel>
                    <Panel header={t('Management')} key="3" style={panelStyle}>
                        <p>{idea?.management}</p>
                    </Panel>
                    <Panel header={t('Value')} key="4" style={panelStyle}>
                        <p>{idea?.value}</p>
                    </Panel>
                    <Panel header={t('Social impact')} key="5" style={panelStyle}>
                        <p>{idea?.socialImpact}</p>
                    </Panel>
                    <Panel header={t('Scalability')} key="6" style={panelStyle}>
                        <p>{idea?.scalability}</p>
                    </Panel>
                    <Panel header={t('Sustainability')} key="7" style={panelStyle}>
                        <p>{idea?.sustainability}</p>
                    </Panel>
                    <Panel header={t('Conclusion')} key="8" style={panelStyle}>
                        <p>{idea?.conclution}</p>
                    </Panel>
                    <Panel header={t('More information')} key="9" style={panelStyle}>
                        {idea && <FormInformation nameIdea={idea?.name} id={idea?.id} />}
                    </Panel>

                </Collapse>
            </div>
        </>
    );
}

export default Idea